import { ArrowLeft, ChevronRight, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { displayRelativeTime } from "@/lib/dateUtils";
import PageTitleScript from "@/components/MetaScript";
import { useTrackedExercises } from "@/hooks/useTrackedExercises";
import { CustomLoader } from "@/components/ui/CustomLoader";
import { CustomLoadingError } from "@/components/ui/CustomLoadingError";
import CustomNoData from "@/components/ui/CustomNoData";
import { Button } from "@/components/ui/button";

export function SettingsExercisesPage() {
  const { data: exercises, isLoading, isError } = useTrackedExercises();

  if (isLoading) {
    return <CustomLoader />;
  }

  if (isError) {
    return <CustomLoadingError />;
  }

  return (
    <div className="flex flex-col p-6">
      <PageTitleScript title="Tracked Exercises" />
      <div className="flex items-center mb-6">
        <Link to="/settings" className="mr-2">
          <ArrowLeft size={24} />
        </Link>
        <h1 className="text-2xl font-bold text-tx-dark">Tracked Exercises</h1>
      </div>

      {exercises?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full gap-4">
          <CustomNoData msg="No exercises found" />
          <Link to="/track">
            <Button variant="outline">
              <Plus size={18} className="mr-2" />
              Track first exercise
            </Button>
          </Link>
        </div>
      ) : (
        <div>
          <div className="flex flex-col space-y-3 p-4 bg-white rounded-lg shadow-md">
            {exercises?.map((exercise) => (
              <Link
                to={`/settings/exercises/${exercise.nano_id}`}
                key={exercise.nano_id}
                className={`flex justify-between items-center p-4 rounded-xl hover:shadow-sm transition-all ${
                  exercise.temperature === "hot"
                    ? "bg-green-50"
                    : exercise.temperature === "warm"
                    ? "bg-blue-50"
                    : "bg-gray-50"
                }`}
              >
                <div className="flex items-start space-x-3">
                  <span
                    className={`w-3 h-3 mt-1 rounded-full ${
                      exercise.temperature === "hot"
                        ? "bg-green-600"
                        : exercise.temperature === "warm"
                        ? "bg-blue-600"
                        : "bg-gray-400"
                    }`}
                  />
                  <div>
                    <p className="font-semibold text-sm text-gray-900">
                      {exercise.name}
                    </p>
                    <p className="text-sm text-gray-500">
                      Last tracked:{" "}
                      {displayRelativeTime(exercise.last_tracked_at)}
                    </p>
                  </div>
                </div>
                <ChevronRight size={18} className="text-gray-400" />
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
